var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M18 21H6a3 3 0 01-3-3V6h15a3 3 0 013 3v9a3 3 0 01-3 3z","opacity":".35"}}),_c('path',{attrs:{"d":"M17.5 12a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM15 3a3 3 0 013 3H3a3 3 0 013-3h9z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }